// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Timeline_entries__1q0-A {
  position: relative;
  padding-top: 1.875rem;
}

.Timeline_entries__1q0-A:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  left: 2.15625rem;
  width: 0.1875rem;
  background: var(--p-color-border,rgba(227, 227, 227, 1));
}

.Timeline_entry__9E7Qy:last-child:after {
  content: "";
  position: absolute;
  top: 50%;
  bottom: 0;
  left: 2.15625rem;
  margin-top: 0.6rem;
  width: 0.1875rem;
  z-index: 1.25;
  background: var(--p-color-border,rgba(227, 227, 227, 1));
}

.Timeline_entry__9E7Qy {
  margin-bottom: 1.25rem;
  margin-top: 0.75rem;
  position: relative;
}

.Timeline_entryBasic__P7VZK {
  display: grid;
  grid-template-columns: 3.84375rem auto auto;
  align-items: center;
  justify-items: left;
  width: 100%;
}

.Timeline_entryBullet__i8FZ0 {
  z-index: 2;
  flex-shrink: 0;
  width: 1.1875rem;
  height: 1.1875rem;
  margin-right: 1.0rem;
  margin-left: 1.65625rem;
  border: 6px solid var(--p-color-border,rgba(227, 227, 227, 1));
  border-radius: 100%;
  background-color: var(--p-color-icon,rgba(74, 74, 74, 1));
}

.Timeline_entryMessage__DS-K1 {
  padding-right: 1rem;
  word-break: break-word;
}

.Timeline_entryMessageText__LfuAs {
  vertical-align: middle;
}

.Timeline_entryMessageWithDetails__9UyOY {
  display: flex;
  cursor: pointer;
}

.Timeline_entryMessage__DS-K1 .Polaris-Icon {
  display: inline-block;
  vertical-align: middle;
  min-width: 1.25rem;
}

.Timeline_entryTime__opIgP {
  justify-self: right;
  margin-right: 1.25rem;
  white-space: nowrap;
  color: var(--p-color-text-secondary,rgba(97, 97, 97, 1));
  height: 1.1875rem
}

.Timeline_entryDetails__2Fxec {
  margin: 0 0.9375rem 0 4.375rem;
}

.Timeline_headerLine__SH6f4 {
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
}

.Timeline_dateLine__MDtiE {
  margin: 0.9375rem 0 1.25rem 3.84375rem;
  color: var(--p-color-text-secondary,rgba(97, 97, 97, 1));
}

.Timeline_diffLine__CXE\\+E {
  display: flex;
  align-items: center;
  margin: 0.0625rem 0 0.6375rem 0;
}

.Timeline_diffLineContent__NCPZM {
  flex: 1 1;
  white-space: pre-line;
  font-size: 0.75rem;
}

.Timeline_diffLineArrow__WVU7t {
  margin: 0 0.9375rem;
}

.Timeline_diffLineArrow__WVU7t > span {
  width: 0.9375rem;
  height: 0.9375rem;
}
`, "",{"version":3,"sources":["webpack://./src/common/Timeline.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,8DAA8D;EAC9D,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,wDAAwD;EACxD;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,SAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".entries {\n  position: relative;\n  padding-top: 1.875rem;\n}\n\n.entries:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  left: 2.15625rem;\n  width: 0.1875rem;\n  background: var(--p-color-border,rgba(227, 227, 227, 1));\n}\n\n.entry:last-child:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  bottom: 0;\n  left: 2.15625rem;\n  margin-top: 0.6rem;\n  width: 0.1875rem;\n  z-index: 1.25;\n  background: var(--p-color-border,rgba(227, 227, 227, 1));\n}\n\n.entry {\n  margin-bottom: 1.25rem;\n  margin-top: 0.75rem;\n  position: relative;\n}\n\n.entryBasic {\n  display: grid;\n  grid-template-columns: 3.84375rem auto auto;\n  align-items: center;\n  justify-items: left;\n  width: 100%;\n}\n\n.entryBullet {\n  z-index: 2;\n  flex-shrink: 0;\n  width: 1.1875rem;\n  height: 1.1875rem;\n  margin-right: 1.0rem;\n  margin-left: 1.65625rem;\n  border: 6px solid var(--p-color-border,rgba(227, 227, 227, 1));\n  border-radius: 100%;\n  background-color: var(--p-color-icon,rgba(74, 74, 74, 1));\n}\n\n.entryMessage {\n  padding-right: 1rem;\n  word-break: break-word;\n}\n\n.entryMessageText {\n  vertical-align: middle;\n}\n\n.entryMessageWithDetails {\n  display: flex;\n  cursor: pointer;\n}\n\n.entryMessage :global(.Polaris-Icon) {\n  display: inline-block;\n  vertical-align: middle;\n  min-width: 1.25rem;\n}\n\n.entryTime {\n  justify-self: right;\n  margin-right: 1.25rem;\n  white-space: nowrap;\n  color: var(--p-color-text-secondary,rgba(97, 97, 97, 1));\n  height: 1.1875rem\n}\n\n.entryDetails {\n  margin: 0 0.9375rem 0 4.375rem;\n}\n\n.headerLine {\n  margin-top: 1.25rem;\n  margin-bottom: 0.5rem;\n}\n\n.dateLine {\n  margin: 0.9375rem 0 1.25rem 3.84375rem;\n  color: var(--p-color-text-secondary,rgba(97, 97, 97, 1));\n}\n\n.diffLine {\n  display: flex;\n  align-items: center;\n  margin: 0.0625rem 0 0.6375rem 0;\n}\n\n.diffLineContent {\n  flex: 1 1 0;\n  white-space: pre-line;\n  font-size: 0.75rem;\n}\n\n.diffLineArrow {\n  margin: 0 0.9375rem;\n}\n\n.diffLineArrow > span {\n  width: 0.9375rem;\n  height: 0.9375rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entries": `Timeline_entries__1q0-A`,
	"entry": `Timeline_entry__9E7Qy`,
	"entryBasic": `Timeline_entryBasic__P7VZK`,
	"entryBullet": `Timeline_entryBullet__i8FZ0`,
	"entryMessage": `Timeline_entryMessage__DS-K1`,
	"entryMessageText": `Timeline_entryMessageText__LfuAs`,
	"entryMessageWithDetails": `Timeline_entryMessageWithDetails__9UyOY`,
	"entryTime": `Timeline_entryTime__opIgP`,
	"entryDetails": `Timeline_entryDetails__2Fxec`,
	"headerLine": `Timeline_headerLine__SH6f4`,
	"dateLine": `Timeline_dateLine__MDtiE`,
	"diffLine": `Timeline_diffLine__CXE+E`,
	"diffLineContent": `Timeline_diffLineContent__NCPZM`,
	"diffLineArrow": `Timeline_diffLineArrow__WVU7t`
};
export default ___CSS_LOADER_EXPORT___;
